/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Vat_Field_LabelInputs */

const vi_order_vat_field_label = /** @type {(inputs: Order_Vat_Field_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thuế VAT`)
};

/**

* @param {Order_Vat_Field_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_vat_field_label = /** @type {((inputs?: Order_Vat_Field_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Vat_Field_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_vat_field_label(inputs)
});